import { useEffect } from 'react';

const useRenderBlueskyEmbeds = (slug: string, update: boolean) => {
  useEffect(() => {
    try {
      (window as any)?.bluesky?.scan?.();
    } catch {
      // no op
    }
  }, [slug, update]);
};

export default useRenderBlueskyEmbeds;
